import { httpV2 } from "@/api";
import RecorderTypes from "@/constants/recorders/RecorderTypes";

/**
 * @summary Promise para os dados dos gráficos de sinais brutos do Pitch.
 * @param {number} signalRegisterId - Id do registro
 * @param {number} recordertype - Numero constante que representa o tipo de registrador que está sendo utilizado.
 * @returns Promise dos Registros de Sinais.
 */
const GetPitchSignalRecords = function(signalRegisteId = 0, recorderType = RecorderTypes.OPERATING)
{
	return httpV2.get(`/PitchSignalRecords/${signalRegisteId}?recorderType=${recorderType}`);
};

export default { GetPitchSignalRecords };